import { render, staticRenderFns } from "./sourcemange.vue?vue&type=template&id=f517492c&scoped=true"
import script from "./sourcemange.vue?vue&type=script&lang=js"
export * from "./sourcemange.vue?vue&type=script&lang=js"
import style0 from "./sourcemange.vue?vue&type=style&index=0&id=f517492c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f517492c",
  null
  
)

export default component.exports